import isServer from "../isServer";
var setGlobalVariable = function setGlobalVariable(name, value) {
  if (isServer()) {
    process.env[name] = value;
  } else {
    window[name] = value;
  }
};
export default setGlobalVariable;